<template>
  <div>
    <PageTable />
  </div>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'plan-noticeInspectionOrder',
  components: { PageTable },
}
</script>
